import { render, staticRenderFns } from "./JiudianZiyuanFenxiDetail.vue?vue&type=template&id=349f1ff0&scoped=true&"
import script from "./JiudianZiyuanFenxiDetail.vue?vue&type=script&lang=js&"
export * from "./JiudianZiyuanFenxiDetail.vue?vue&type=script&lang=js&"
import style0 from "./JiudianZiyuanFenxiDetail.vue?vue&type=style&index=0&id=349f1ff0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349f1ff0",
  null
  
)

export default component.exports